import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";

export default class Toggle extends React.PureComponent {
	render() {
		const blockClasses = clsx("Toggle", this.props.small && "Toggle--small", this.props.className);
		return (
			<label className={blockClasses} title={this.props.titleTooltip} disabled={this.props.toggleDisabled}>
				<input
					type="checkbox"
					disabled={this.props.toggleDisabled}
					className={"Toggle_control"}
					checked={this.props.checked}
					onChange={(ev) => this.props.onChange(ev.target.checked)}
				/>
				<div className={"Toggle_track"} />
			</label>
		);
	}
}

Toggle.propTypes = {
	titleTooltip: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	small: PropTypes.bool,
	className: PropTypes.string,
	toggleDisabled: PropTypes.bool,
	checked: PropTypes.bool.isRequired,
	onChange: PropTypes.func.isRequired,
};
